// require('./jquery');
require('./bootstrap');
require('./jquery.form');
require('./jquery.validate.min');
// require('./sweetalert.min');
require('./bootstrap-select.min');
require('./persian.min');
require('./map/leaflet');
require('./owl.carousel.min');
// require('./chat');

let siteBody = document.querySelector('body');
let fastBtn = document.querySelector('#fast_side-btn');
let fastMenu = document.querySelector('.userpanel_menu2');
let fastMenuItems = [...document.querySelectorAll('.fast_menu-item')];
let fastBackDrop = document.querySelector('.menu_two--backdrop');
let stickyMenuToTop = 0;
let tempWidth = window.innerWidth;
let firstTouch = 0;
const menuActivator = () => {
    fastBtn.classList.add('active');
    fastMenu.classList.add('active');
    siteBody.classList.add('fast_menu-opened');
    //disableOnshowLeftMenu
    $('#disableOnshowLeftMenu').animate({
        "width": 100 + '%',
        "opacity": 0.7,
    }, 500)
};
const menuDeactivator = () => {
    fastBtn.classList.remove('active');
    fastMenu.classList.remove('active');
    siteBody.classList.remove('fast_menu-opened');
    $('#disableOnshowLeftMenu').animate({
        "width": 0 + 'px',
        "opacity": 0,
    }, 500)
};
if (fastBtn) {
    fastBtn.addEventListener('click', () => {
        if (!fastBtn.classList.contains('active')) {
            menuActivator();
        } else {
            menuDeactivator();
        }
    });

    $('#disableOnshowLeftMenu').on('click', function () {
        if (fastBtn.classList.contains('active')) {
            menuDeactivator();
        }
    })
}
window.addEventListener('click', (e) => {
    if (e.target === fastBackDrop) {
        menuDeactivator();
    }
});
fastMenuItems.forEach(item => {
    item.addEventListener('click', (event) => {
        let filtered = fastMenuItems.filter(item => {
            return item !== event.currentTarget;
        });
        filtered.forEach(item => {
            item.classList.remove('active');
            item.nextElementSibling.style.cssText = `maxHeight:${null}`;
        });
        if (!event.currentTarget.classList.contains('active')) {
            event.currentTarget.classList.add('active');
            event.currentTarget.nextElementSibling.style.cssText = `max-height:${event.currentTarget.nextElementSibling.firstElementChild.getBoundingClientRect().height}px`;
        } else {
            event.currentTarget.classList.remove('active');
            event.currentTarget.nextElementSibling.style.cssText = `maxHeight:${null}`;
        }
    });
});


    function toEnglishNumber(strNum) {
        var pn = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
        var en = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
        var an = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];
        var cache = strNum;
        for (var i = 0; i < 10; i++) {
            var regex_fa = new RegExp(pn[i], 'g');
            var regex_ar = new RegExp(an[i], 'g');
            cache = cache.replace(regex_fa, en[i]);
            cache = cache.replace(regex_ar, en[i]);
        }
        return cache;
    }



    $('select').on('change',function (){
        if ($(this).val() != ""){
            $('.'+$(this).attr('id')+'-has-error-from-validate').hide();
        }else{
            $('.'+$(this).attr('id')+'-has-error-from-validate').show();
        }
    })



    // When the user scrolls down 20px from the top of the document, show the button
    $(window).scroll(function(){scrollFunction()})

    function scrollFunction() {
        var showScrollPoint =$(window).height();
        var showScrollPoint2 =$(document).height();
        var showScrollPointFinal = showScrollPoint2 - showScrollPoint - 200;
        if (document.body.scrollTop > showScrollPointFinal || document.documentElement.scrollTop > showScrollPointFinal || document.documentElement.scrollTop > 250) {
            $('#goToTopBtn').show(500)
        } else {
            $('#goToTopBtn').hide(500)
        }
    }


    // show info under input fields on focus
    $('.input-has-info').on('focus',function (){
        if (!$(this).hasClass('input-has-error')){
            if ($(this).val().length > 2){
                $('#'+$(this).attr('id')+'-info').hide();
            }else{
                $('#'+$(this).attr('id')+'-info').show();
            }
        }
    })
    $('.input-has-info').on('keyup',function (e){
        if (!$(this).hasClass('input-has-error')){
            $('#'+$(this).attr('id')+'-info').show();
            if ($(this).val().length > 2){
                $('#'+$(this).attr('id')+'-info').hide();
            }
            if (e.keyCode === 13){
                $('#'+$(this).attr('id')+'-info').hide();
                var nextI = $("input").index(this)+1,
                    next=$("input").eq(nextI);
                next.focus();
            }
        }
    })
    $(document).on('keyup','.EnVal',function (e){
        EnValthisVal= persianJs($(this).val()).switchKey();
        $(this).val(EnValthisVal);
        if (e.keyCode === 13) {
            $('#'+$(this).attr('id')+'-info').hide();
            var nextI = $("input").index(this)+1,
                next=$("input").eq(nextI);
            next.focus();
        }
    });
    $(document).on('focusout','.input-has-info',function (){
        $('#'+$(this).attr('id')+'-info').hide();
    })


    $(document).on('input','input',function (){
        var inputValToConvertEn=toEnglishNumber($(this).val());
        $(this).val(inputValToConvertEn);
        if ($(this).hasClass('input-has-error')){
            if ($(this).val().length > 0){
                $(this).removeClass('input-has-error');
                $(this).parent().find('.has-error').hide();
                $('span.'+$(this).attr('name')+'-has-error-from-validate').hide();
            }
        }
    });

    $(document).on('keyup','textarea',function (){
        var inputValToConvertEn=toEnglishNumber($(this).val());
        $(this).val(inputValToConvertEn);
        if ($(this).hasClass('input-has-error')){
            if ($(this).val().length > 2){
                $(this).removeClass('input-has-error');
                $('span.'+$(this).attr('name')+'-has-error-from-validate').hide();
            }
        }
    });
jQuery.fn.scrollToMyElement = function(elem, speed,margin_bottom=0) {
    var $this = jQuery(this);
    var $this_top = $this.offset().top;
    var $this_bottom = $this_top + $this.height();
    var $elem = jQuery(elem);
    var $elem_top = $elem.offset().top;
    var $elem_bottom = $elem_top + $elem.height() + margin_bottom;

    if ($elem_top > $this_top && $elem_bottom < $this_bottom) {
        // in view so don't do anything
        return;
    }
    var new_scroll_top;
    if ($elem_top < $this_top) {
        new_scroll_top = {scrollTop: $this.scrollTop() - $this_top + $elem_top};
    } else {
        new_scroll_top = {scrollTop: $elem_bottom - $this_bottom + $this.scrollTop()};
    }
    $this.animate(new_scroll_top, speed === undefined ? 100 : speed);
    return this;
};
String.prototype.nl2br = function()
{
    return this.replace(/\n/g, "<br />").trim();
};
String.prototype.br2nl = function()
{
    return this.replace("<br >", " ", "g").replace("<br>", " ", "g").trim();
};
String.prototype.removeNl = function()
{
    return this.replace(/\n/g, " ").trim();
};
require('./dragscroll')
require('./audio_record/WebAudioRecorder');


var MainWidthZommableImage=0;
var MainHeightZommableImage=0;
$(document).on('click','.showImageInModal',function (){
    $('#scaleImageModalRange').val('0');
    $('#showImageInModalFullScreenPhoto').attr('src',$(this).attr('src'));
    $('#showImageInModalFullScreenPhoto').css({'max-width':'100%'});
    $('#showImageInModalFullScreenPhoto').css({'max-height':'100%'});
    $('#showImageInModalFullScreenPhoto').css({'width':'unset'});
    $('#showImageInModalFullScreenPhoto').css({'height':'unset'});
    $('#showImageInModalFullScreenModal').modal('show');
    setTimeout(function (){
        MainWidthZommableImage=$('#showImageInModalFullScreenPhoto').width();
        MainHeightZommableImage=$('#showImageInModalFullScreenPhoto').height();
    },200)
    setTimeout(function (){
        MainWidthZommableImage=$('#showImageInModalFullScreenPhoto').width();
        MainHeightZommableImage=$('#showImageInModalFullScreenPhoto').height();
    },500)
    setTimeout(function (){
        MainWidthZommableImage=$('#showImageInModalFullScreenPhoto').width();
        MainHeightZommableImage=$('#showImageInModalFullScreenPhoto').height();
    },1000)


});
$( "#showImageInModalFullScreenModal" ).on('shown', function(){
    MainWidthZommableImage=$('#showImageInModalFullScreenPhoto').width();
    MainHeightZommableImage=$('#showImageInModalFullScreenPhoto').height();
});
$('#scaleImageModalRange').on('input',function (){
    chekScaleInImageModal();
});
function chekScaleInImageModal(){
    var showInModalImage_width=MainWidthZommableImage;
    var showInModalImage_height=MainHeightZommableImage;
    var ScaleVal= parseInt($('#scaleImageModalRange').val());
    showInModalImage_width=((showInModalImage_width * ScaleVal) / 100) + showInModalImage_width;
    $('#showImageInModalFullScreenPhoto').width(showInModalImage_width);
    $('#showImageInModalFullScreenPhoto').css({'max-width':showInModalImage_width});
    showInModalImage_height=((showInModalImage_height * ScaleVal) / 100) + showInModalImage_height;
    $('#showImageInModalFullScreenPhoto').height(showInModalImage_height);
    $('#showImageInModalFullScreenPhoto').css({'max-height':showInModalImage_height});
    var SIIMFSPEL=document.getElementById('showImageInModalFullScreenPhoto')
    var SIIMFSPELLeft = SIIMFSPEL.offsetLeft;
    if (SIIMFSPELLeft < 0){
        SIIMFSPEL.parentNode.scrollLeft = SIIMFSPELLeft / 2
    }
    $('#showImageInModalFullScreenBody').scrollTop((SIIMFSPEL.scrollHeight - $('#showImageInModalFullScreenBody').height()) / 2)
}
$('#showImageInModalFullScreenModal').on('wheel', function(e) {
    e.preventDefault();
    if ($('#showImageInModalFullScreenModal').is(':visible')){
        var delta = e.originalEvent.deltaY;
        var scaleImageModalRange= parseFloat($('#scaleImageModalRange').val());
        var step = parseFloat($('#scaleImageModalRange').attr('step')) * 10;
        if (delta > 0){
            // going down
            scaleImageModalRange = scaleImageModalRange - step ;
        }else{
            // going up
            scaleImageModalRange = scaleImageModalRange + step ;
        }
        $('#scaleImageModalRange').val(scaleImageModalRange);
        chekScaleInImageModal();
    }

});

$('#changePassType').on('click',function (){
    if ($('#password').prop('type') == 'password'){
        $('#password').prop("type", "text").attr("type", "text");
    }else{
        $('#password').prop("type", "password").attr("type", "password");
    }
});




// When the user clicks on the button, scroll to the top of the document
function topFunction() {
    $('html, body').animate({ scrollTop: 0 }, 'slow', function () {});
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}

$('#goToTopBtn').on('click',function (){
    topFunction();
})

document.addEventListener('scroll', function (event) {
    var scrollingTarget=event.target;
    if ($(scrollingTarget).hasClass('fileTabPane') && $(scrollingTarget).hasClass('active')){
        $('#goToTopBtn').hide();
        if ($(scrollingTarget).scrollTop() > 100){
            $('#goToTopBtnTabPane').show(500);
        }else{
            $('#goToTopBtnTabPane').hide(500);
        }
    }
}, true);

$('#goToTopBtnTabPane').on('click',function (){
    $('.fileTabPane.active').animate({ scrollTop: 0 }, 'slow', function () {});
    $('.fileTabPane.active').scrollTop = 0;
})


$('.showHelp').on('click',function (e){
    e.preventDefault();
    var helpId=$(this).attr('data-id');
    $('#showHelpModalBody').html('<div class="spinner-border text-success"></div>');
    $('#showHelpModalBodyTooltip').html('<div class="spinner-border text-success"></div>');
    $.ajax({
        data: {
            _token : $('input[name="_token"]').val(),
            code : helpId,
        },
        type: "POST",
        url: window.location.origin+"/getHelp",
        success: function (response) {
            $('input[name="_token"]').val(response.token);
            if (response.response){
                if(response.type == 'iframe'){
                    $('#showHelpModalBody').html(response.iframe);
                    $('#showHelpModal').modal('show');
                }else{
                    $('#showHelpModalBodyTooltip').html(response.tooltip);
                    $('#showHelpModalTooltip').modal('show');
                }

            }
        }
    });

});
$(document).ready(function(){
    $('[data-show_title="tooltip"]').tooltip();
});



